
import {Component, Vue, Watch} from "vue-property-decorator";
import {instituteAssignmentModule, instituteModule, studyInstitutesModule, usersModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import TextField from "@/components/study/datafields/TextField.vue";
import {StringCompare} from "@/auxillary/sorting";
import {rules} from '@/auxillary/rules';
import IShortUserDto = MdbsCore.IShortUserDto;
import IStudyInstituteShortDto = MdbsCore.IStudyInstituteShortDto;
import InstituteCompleteDto = MdbsCore.InstituteCompleteDto;

@Component({
  components: {TextField},
})
export default class InstituteToUserAssignment extends Vue {
  private selectedUserModel: string = "";
  private selectedInstituteModel: string[] = [];
  private assignedInstitutes: string[] = [];
  private filterInstituteModel: string = "";
  private institutes = new Array<InstituteCompleteDto>();

  private saving = false;
  private showSuccessMessage = false;
  rules = rules;
  valid = false;

  @Watch("selectedUserModel", {immediate: true})
  async handleSelectedUserChanged(newUserId: string) {
    await this.initializeInstituteData(newUserId);

    Vue.nextTick(() => {
      this.form.validate();
    });
  }

  /**
   * Refresh all institutes to get updated assignments
   *
   * @param userId
   */
  async initializeInstituteData(userId: string) {
    if (!userId) {
      this.selectedInstituteModel = [];
      this.assignedInstitutes = [];
      return;
    }
    this.institutes = await instituteModule.getAllComplete()
    await instituteModule.loadAll();
    await studyInstitutesModule.loadAll();

    this.selectedInstituteModel =  this.institutes
        .filter(institute => institute.users?.some(u => userId == u))
        .map(institute => institute.id)
        .filter(institute => studyInstitutesModule
            .studyInstitutes
            .map(si => si.instituteId)
            .includes(institute));
    this.assignedInstitutes = [...this.selectedInstituteModel];
  }

  /**
   * id contains the instituteId of the displayed StudyInstitute
   */
  get treeItems() {
    const buildTreeItem = (id: string, name: string, children: any[]) => {
      return {id, name, children};
    };

    const buildInstituteLabel = (institute: IStudyInstituteShortDto) => `${institute.identifier} - ${institute.displayName}`;
    const buildParentTreeItem = () => buildTreeItem("0", "Alle Zentren", []);
    const buildInstituteTreeItem = (institute: IStudyInstituteShortDto) => buildTreeItem(institute.instituteId ?? "", buildInstituteLabel(institute), []);

    const result = buildParentTreeItem();
    result.children = [...studyInstitutesModule
        .studyInstitutes
        .map(buildInstituteTreeItem)
        .sort((i1, i2) => StringCompare(i1.name, i2.name))
    ];
    return [result];
  }

  get allUsers() {
    return usersModule.users;
  }

  getUserName(user: IShortUserDto) {
    return user.userName + " - " + user.displayName
  }

  async handleSave() {
    try {
      this.saving = true;

      await instituteAssignmentModule.assignInstitutesToUser({
        userId: this.selectedUserModel,
        instituteIds: this.selectedInstituteModel
      });

      this.showSuccessMessage = true;
    } finally {
      this.saving = false;

      await this.initializeInstituteData(this.selectedUserModel);
    }
  }

  get hasChanges(): boolean {
    return !!this.selectedUserModel && this.countChanges > 0;
  }

  get countChanges(): number {
    if (!this.selectedUserModel || this.loading) {
      return 0;
    }

    const addedSelectionsCount = this.selectedInstituteModel.filter(si => !this.assignedInstitutes.some(ai => ai == si)).length;
    const removedSelectionCount = this.assignedInstitutes.filter(ai => !this.selectedInstituteModel.some(si => si == ai)).length;

    return addedSelectionsCount + removedSelectionCount;
  }

  get loading() {
    return instituteModule.isLoading || usersModule.isLoading || instituteAssignmentModule.isLoading || studyInstitutesModule.isLoading;
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  appendIcon(item: any, selected: boolean): any {
    const result = {icon: '', color: ''};
    if (item.children.length > 0) {
      return result;
    }
    const isInPreSelection = this.assignedInstitutes.includes(item.id);
    if (!isInPreSelection && selected) {
      result.icon = 'fa-plus-circle';
      result.color = 'green';
      return result;
    }
    if (isInPreSelection && !selected) {
      result.icon = 'fa-minus-circle';
      result.color = 'red';
      return result;
    }
    return result;
  }
}

